<section class="container">
  <header>
    <i
      matTooltip="Cerrar"
      class="fas fa-times fa-2xl cursor-pointer"
      style="float: right;"
      (click)="ref.close()"
    ></i>
    <div class="title-component text-center">{{ title }}</div>
    <p>Detalle de los pagos transferidos a este servicio.</p>
  </header>
  <main>
    <div class="container movements-container px-0">
      <div
        *ngFor="let payment of payments; let i = index"
        class="row movement-item"
        [ngClass]="{ 'background-gray': i % 2 === 0 }"
      >
        <div class="col-md-6 d-flex flex-column mb-2">
          <b class="bold d-block mb-1">Pago original</b>
          <small class="d-block mb-1">
            <span class="text-bold">Fecha de pago:</span>
            <span>
              {{ payment?.date | date: 'yyyy/MM/dd HH:mm' }}
            </span>
          </small>
          <small class="d-block mb-1" *ngIf="payment?.userId">
            <span class="text-bold">Documento quien pagó: </span>
            <span>{{ payment.userId }}</span>
          </small>
          <small class="d-block mb-1" *ngIf="payment?.userId || payment?.userName">
            <span class="text-bold">Nombre quien pagó: </span>
            <span>
              {{
                users[payment.userId]?.information?.name
                  || payment.userName
                  || '-'
              }}
            </span>
          </small>
          <small class="d-block mb-1" *ngIf="payment?.type">
            <span class="text-bold">Tipo de pago: </span>
            <span>{{ getPaymentTypeLabel(payment.type) }}</span>
          </small>
          <small class="d-block mb-1">
            <span class="text-bold">Monto: </span>
            <span class="text-info bold">
              {{ payment.amount | currency: 'COP' }}
            </span>
          </small>
        </div>
        <div
          class="col-md-6 d-flex flex-column mb-2"
          *ngIf="payment?.fingerPrintObservation?.fingerPrint"
        >
          <b class="bold d-block mb-1">Responsable de la transferencia</b>
          <small class="d-block mb-1">
            <span class="text-bold">Documento responsable: </span>
            <span>
              {{ payment.fingerPrintObservation.fingerPrint?.userId || '-' }}
            </span>
          </small>
          <small class="d-block mb-1">
            <span class="text-bold">Nombre responsable: </span>
            <span>
              {{
                payment.fingerPrintObservation.fingerPrint?.userName || '-'
              }}
            </span>
          </small>
          <small
            class="d-block mb-1"
            *ngIf="payment.fingerPrintObservation.fingerPrint?.date"
          >
            <span class="text-bold">Fecha de transferencia: </span>
            <span>
              {{
                payment.fingerPrintObservation.fingerPrint.date
                  | date: 'yyyy/MM/dd HH:mm'
              }}
            </span>
          </small>
        </div>
        <div
          class="col-12 mt-1"
          *ngIf="payment?.fingerPrintObservation?.observation"
        >
          <small>
            <span class="text-bold">Motivo de la transferencia:</span>
            <br />
            <i>{{ payment.fingerPrintObservation.observation }}</i>
          </small>
        </div>
      </div>
    </div>
  </main>
  <br />
  <footer>
    <div class="text-center">
      <button
        mat-raised-button
        color="accent"
        class="m-auto"
        (click)="ref.close()"
      >
        Aceptar
      </button>
    </div>
  </footer>
</section>

